export const SolutionsList = [
  {
    name: 'Turnkey',
    slug: 'turnkey',
    path: 'solutions#turnkey',
    description: 'Turnkey functions with your licence and wallet (you need to already have those!), alongside the software from BetConstruct. With the Turnkey solution, you deal with legal and financial matters, while we provide the software for your business. The software provision is flexible and customisable. You can choose the platform’s design, structure and tell us your preferences.',
    nestedSubMenu: {
      products: [
        {
          name: 'Sportsbook',
          slug: 'sportsbook',
          icon: 'sportsbook',
          path: 'products/sportsbook',
          description: 'A complete Sportsbook platform with live and pre-match betting.',
        },
        {
          name: 'Casino Suite',
          slug: 'casinoSuite',
          icon: 'casinoSuite',
          path: 'products/casinoSuite',
          description: '7,000 casino games from BetConstruct and other major suppliers.',
        },
        {
          name: 'Virtual Sports',
          slug: 'virtualSports',
          icon: 'virtualSports',
          path: 'products/virtualSports',
          description: 'Real-money betting on various 3D-designed sports\n.',
        },
        {
          name: 'Backgammon',
          slug: 'backgammon',
          icon: 'backgammon',
          path: 'products/backgammon',
          description: '7 game variations. Multi-platform experience. User-friendly design. Highly-customisable settings.',
        },
        {
          name: 'Live Casino',
          slug: 'liveCasino',
          icon: 'liveCasino',
          path: 'products/liveCasino',
          description: 'A high-quality and competitively priced gateway with new generation famous casino and hybrid games.',
        },
        {
          name: 'Skill Games',
          slug: 'skillGames',
          icon: 'skillGames',
          path: 'products/skillGames',
          description: 'A traditional casino alternative with Chinese Poker, Backgammon, and Belote.',
        },
        {
          name: 'Poker',
          slug: 'poker',
          icon: 'poker',
          path: 'products/poker',
          description: 'Poker games with intuitive design and highly-customisable settings.',
        },
        {
          name: 'Live sports video streaming',
          slug: 'liveSports',
          icon: 'liveSports',
          path: 'products/liveSports',
          description: 'Exclusive live or on-demand video streaming for players and bookmakers.',
        },
        {
          name: 'Friendship',
          slug: 'friendShip',
          icon: 'friendship',
          path: 'products/friendShip',
          description: 'Real-time quality data and digital content to be booked.',
        },
        {
          name: 'Statistics',
          slug: 'statistics',
          icon: 'statistics',
          path: 'products/statistics',
          description: 'A wide range of sports information based on historical and near-live data\n.',
        },
        {
          name: 'Social Gaming',
          slug: 'socialGaming',
          icon: 'socialGaming',
          path: 'products/socialGaming',
          description: 'Custom-built social games with unforgettable casino experience.',
        },
        {
          name: 'Odds Display',
          slug: 'oddsDisplay',
          icon: 'liveMonitor',
          path: 'products/liveMonitor',
          description: 'All sports events and their markets exclusively displayed in one place.',
        },
        {
          name: 'Self Service Betting Terminal',
          slug: 'terminal',
          icon: 'terminal',
          path: 'products/terminal',
          description: 'C#-technology self-service betting terminal software for your WindowsOS cabinets and hardware.',
        },
        {
          name: 'Betshop Client',
          slug: 'betshopClient',
          icon: 'betShopClient',
          path: 'products/betShopClient',
          description: 'Take bets, pay off bets, register clients, accept deposits and process withdrawal requests.',
        },
        {
          name: 'Pocket Betshop',
          slug: 'pocketBetshop',
          icon: 'betShopPocket',
          path: 'products/betShopPocket',
          description: 'Sortable AndroidOS software to help agents serve players.',
        },
        {
          name: 'Live Scouting Data',
          slug: 'liveScoutData',
          icon: 'liveScoutDataIcon',
          path: 'products/liveScoutData',
          description: 'Live Scouting Data provides fast and reliable live data for popular sports from all over the world.',
        },
        {
          name: 'Betting Games Software',
          slug: 'bettingGames',
          icon: 'bettingGames',
          path: 'products/bettingGames',
          description: 'BetConstruct in-house-developed and 3rd-party games for your iGaming business.',
        },
      ],
      tools: [
        {
          name: 'CRM',
          slug: 'crm',
          icon: 'crm',
          path: 'tools/crm',
          description: 'Run data-driven marketing campaigns, customise your offerings and meet modern challenges in acquisition and retention with this automated marketing and analytics CRM tool.',
        },
        {
          name: 'Affiliate Marketing',
          slug: 'affiliate',
          icon: 'affiliate',
          path: 'tools/affiliate',
          description: 'Easily set up, expand and manage your affiliate network with one of the most complete affiliate creation and management systems available today.',
        },
        {
          name: 'Umbrella',
          slug: 'umbrella',
          icon: 'umbrella',
          path: 'tools/umbrella',
          description: 'An AI-powered risk management solution, designed to detect and manage potential risks.',
        },
        {
          name: 'Agent System',
          slug: 'agentSystem',
          icon: 'agentSystem',
          path: 'tools/agent-system',
          description: 'Expand your player base through a manageable hierarchy of agent networks.',
        },
      ],
      payments: [
        {
          name: 'Payments',
          slug: 'payments',
          icon: 'payments',
          path: 'payments/payments',
          description: 'Set up your own payment method via SpringBME or enable any of the existing ones.',
        },
      ],
    }
  },
  {
    name: 'WhiteLabel',
    slug: 'whiteLabel',
    path: 'solutions#whiteLabel',
    description: 'White label suggests that we provide the whole package from scratch as a ready-to-operate solution that has been tested and perfected many times. It all works under our licence and with our software. We take care of all the legal, financial and administrative matters. No matter how ready-made, this solution can still be customised according to your needs.',
    nestedSubMenu: {
      products: [
        {
          name: 'Sportsbook',
          slug: 'sportsbook',
          icon: 'sportsbook',
          path: 'products/sportsbook',
          description: 'A complete Sportsbook platform with live and pre-match betting.',
        },
        {
          name: 'Casino Suite',
          slug: 'casinoSuite',
          icon: 'casinoSuite',
          path: 'products/casinoSuite',
          description: '7,000 casino games from BetConstruct and other major suppliers.',
        },
        {
          name: 'Virtual Sports',
          slug: 'virtualSports',
          icon: 'virtualSports',
          path: 'products/virtualSports',
          description: 'Real-money betting on various 3D-designed sports\n.',
        },
        {
          name: 'Backgammon',
          slug: 'backgammon',
          icon: 'backgammon',
          path: 'products/backgammon',
          description: '7 game variations. Multi-platform experience. User-friendly design. Highly-customisable settings.',
        },
        {
          name: 'Live Casino',
          slug: 'liveCasino',
          icon: 'liveCasino',
          path: 'products/liveCasino',
          description: 'A high-quality and competitively priced gateway with new generation famous casino and hybrid games.',
        },
        {
          name: 'Skill Games',
          slug: 'skillGames',
          icon: 'skillGames',
          path: 'products/skillGames',
          description: 'A traditional casino alternative with Chinese Poker, Backgammon, and Belote.',
        },
        {
          name: 'Poker',
          slug: 'poker',
          icon: 'poker',
          path: 'products/poker',
          description: 'Poker games with intuitive design and highly-customisable settings.',
        },
        {
          name: 'Live sports video streaming',
          slug: 'liveSports',
          icon: 'liveSports',
          path: 'products/liveSports',
          description: 'Exclusive live or on-demand video streaming for players and bookmakers.',
        },
        {
          name: 'Friendship',
          slug: 'friendShip',
          icon: 'friendship',
          path: 'products/friendShip',
          description: 'Real-time quality data and digital content to be booked.',
        },
        {
          name: 'Statistics',
          slug: 'statistics',
          icon: 'statistics',
          path: 'products/statistics',
          description: 'A wide range of sports information based on historical and near-live data\n.',
        },
        {
          name: 'Social Gaming',
          slug: 'socialGaming',
          icon: 'socialGaming',
          path: 'products/socialGaming',
          description: 'Custom-built social games with unforgettable casino experience.',
        },
        {
          name: 'Live Scouting Data',
          slug: 'liveScoutData',
          icon: 'liveScoutDataIcon',
          path: 'products/liveScoutData',
          description: 'Live Scouting Data provides fast and reliable live data for popular sports from all over the world.',
        },
        {
          name: 'Betting Games Software',
          slug: 'bettingGames',
          icon: 'bettingGames',
          path: 'products/bettingGames',
          description: 'BetConstruct in-house-developed and 3rd-party games for your iGaming business.',
        },
      ],
      tools: [
        {
          name: 'CRM',
          slug: 'crm',
          icon: 'crm',
          path: 'tools/crm',
          description: 'Run data-driven marketing campaigns, customise your offerings and meet modern challenges in acquisition and retention with this automated marketing and analytics CRM tool.',
        },
        {
          name: 'Affiliate Marketing',
          slug: 'affiliate',
          icon: 'affiliate',
          path: 'tools/affiliate',
          description: 'Easily set up, expand and manage your affiliate network with one of the most complete affiliate creation and management systems available today.',
        },
        {
          name: 'Umbrella',
          slug: 'umbrella',
          icon: 'umbrella',
          path: 'tools/umbrella',
          description: 'An AI-powered risk management solution, designed to detect and manage potential risks.',
        },
        {
          name: 'Agent System',
          slug: 'agentSystem',
          icon: 'agentSystem',
          path: 'tools/agent-system',
          description: 'Expand your player base through a manageable hierarchy of agent networks.',
        },
      ],
    },
  },
  {
    name: 'Odds Feed',
    slug: 'oddsFeed',
    path: 'solutions#oddsFeed',
    description: `Over 300 professional traders behind an odds feed system that's robust, responsive and ready to deliver. Get full access to 840K+ live matches and 1,68M+ pre-matches annually on sporting events from around the world! Let your business benefit from our accurate and efficient sports betting data.`,
    nestedSubMenu: {
      products: [
        {
          name: 'Friendship',
          slug: 'friendShip',
          icon: 'friendship',
          path: 'products/friendShip',
          description: 'Real-time quality data and digital content to be booked.',
        },
        {
          name: 'Odds Feed',
          slug: 'oddsFeed',
          icon: 'oddsFeed',
          path: 'products/oddsFeed',
          description: 'Let your business benefit from our accurate and efficient sports betting data.',
        },
      ],
    },
  },
  {
    name: 'Casino API',
    slug: 'casinoApi',
    path: 'solutions#casinoApi',
    description: 'With API (aka Data Integrations), you integrate our platform into your existing solution via API. As you may know, API is basically a component that allows different platforms, applications and systems to connect and share information. Various types of software can be interlinked and interconnected with dedicated tools to streamline required processes. API simplifies the implementation of new applications, business models and digital products. As part of this solution, BetConstruct offers Sportsbook API and Casino API. Note: If you are starting a business from scratch, this solution may not be the best option for your brand at an early stage. Go for it, if you have an already-existing operation.',
    nestedSubMenu: {
      products: [
        {
          name: 'Casino Suite',
          slug: 'casinoSuite',
          icon: 'casinoSuite',
          path: 'products/casinoSuite',
          description: '7,000 casino games from BetConstruct and other major suppliers.',
        },
        {
          name: 'Virtual Sports',
          slug: 'virtualSports',
          icon: 'virtualSports',
          path: 'products/virtualSports',
          description: 'Real-money betting on various 3D-designed sports\n.',
        },
        {
          name: 'Backgammon',
          slug: 'backgammon',
          icon: 'backgammon',
          path: 'products/backgammon',
          description: '7 game variations. Multi-platform experience. User-friendly design. Highly-customisable settings.',
        },
        {
          name: 'Live Casino',
          slug: 'liveCasino',
          icon: 'liveCasino',
          path: 'products/liveCasino',
          description: 'A high-quality and competitively priced gateway with new generation famous casino and hybrid games.',
        },
        {
          name: 'Skill Games',
          slug: 'skillGames',
          icon: 'skillGames',
          path: 'products/skillGames',
          description: 'A traditional casino alternative with Chinese Poker, Backgammon, and Belote.',
        },
        {
          name: 'Poker',
          slug: 'poker',
          icon: 'poker',
          path: 'products/poker',
          description: 'Poker games with intuitive design and highly-customisable settings.',
        },
        {
          name: 'Social Gaming',
          slug: 'socialGaming',
          icon: 'socialGaming',
          path: 'products/socialGaming',
          description: 'Custom-built social games with unforgettable casino experience.',
        },
        {
          name: 'Odds Display',
          slug: 'oddsDisplay',
          icon: 'liveMonitor',
          path: 'products/liveMonitor',
          description: 'All sports events and their markets exclusively displayed in one place',
        },
        {
          name: 'Self Service Betting Terminal',
          slug: 'terminal',
          icon: 'terminal',
          path: 'products/terminal',
          description: 'C#-technology self-service betting terminal software for your WindowsOS cabinets and hardware.',
        },
        {
          name: 'Betshop Client',
          slug: 'betshopClient',
          icon: 'betShopClient',
          path: 'products/betShopClient',
          description: 'Take bets, pay off bets, register clients, accept deposits and process withdrawal requests.',
        },
        {
          name: 'Pocket Betshop',
          slug: 'pocketBetshop',
          icon: 'betShopPocket',
          path: 'products/betShopPocket',
          description: 'Sortable AndroidOS software to help agents serve players.',
        },
        {
          name: 'Betting Games Software',
          slug: 'bettingGames',
          icon: 'bettingGames',
          path: 'products/bettingGames',
          description: 'BetConstruct in-house-developed and 3rd-party games for your iGaming business.',
        },
      ],
    },
  },
  {
    name: 'Sportsbook API',
    slug: 'sportsbookApi',
    path: 'solutions#sportsbookApi',
    description: 'With API (aka Data Integrations), you integrate our platform into your existing solution via API. As you may know, API is basically a component that allows different platforms, applications and systems to connect and share information. Various types of software can be interlinked and interconnected with dedicated tools to streamline required processes. API simplifies the implementation of new applications, business models and digital products. As part of this solution, BetConstruct offers Sportsbook API and Casino API. Note: If you are starting a business from scratch, this solution may not be the best option for your brand at an early stage. Go for it, if you have an already-existing operation.',
    nestedSubMenu: {
      products: [
        {
          name: 'Sportsbook',
          slug: 'sportsbook',
          icon: 'sportsbook',
          path: 'products/sportsbook',
          description: 'A complete Sportsbook platform with live and pre-match betting.',
        },
        {
          name: 'Virtual Sports',
          slug: 'virtualSports',
          icon: 'virtualSports',
          path: 'products/virtualSports',
          description: 'Real-money betting on various 3D-designed sports\n.',
        },
        {
          name: 'Live sports video streaming',
          slug: 'liveSports',
          icon: 'liveSports',
          path: 'products/liveSports',
          description: 'Exclusive live or on-demand video streaming for players and bookmakers.',
        },
        {
          name: 'Friendship',
          slug: 'friendShip',
          icon: 'friendship',
          path: 'products/friendShip',
          description: 'Real-time quality data and digital content to be booked.',
        },
        {
          name: 'Statistics',
          slug: 'statistics',
          icon: 'statistics',
          path: 'products/statistics',
          description: 'A wide range of sports information based on historical and near-live data\n.',
        },
        {
          name: 'Social Gaming',
          slug: 'socialGaming',
          icon: 'socialGaming',
          path: 'products/socialGaming',
          description: 'Custom-built social games with unforgettable casino experience.',
        },
        {
          name: 'Odds Display',
          slug: 'oddsDisplay',
          icon: 'liveMonitor',
          path: 'products/liveMonitor',
          description: 'All sports events and their markets exclusively displayed in one place',
        },
        {
          name: 'Self Service Betting Terminal',
          slug: 'terminal',
          icon: 'terminal',
          path: 'products/terminal',
          description: 'C#-technology self-service betting terminal software for your WindowsOS cabinets and hardware.',
        },
        {
          name: 'Betshop Client',
          slug: 'betshopClient',
          icon: 'betShopClient',
          path: 'products/betShopClient',
          description: 'Take bets, pay off bets, register clients, accept deposits and process withdrawal requests.',
        },
        {
          name: 'Pocket Betshop',
          slug: 'pocketBetshop',
          icon: 'betShopPocket',
          path: 'products/betShopPocket',
          description: 'Sortable AndroidOS software to help agents serve players.',
        },
        {
          name: 'Live Scouting Data',
          slug: 'liveScoutData',
          icon: 'liveScoutDataIcon',
          path: 'products/liveScoutData',
          description: 'Live Scouting Data provides fast and reliable live data for popular sports from all over the world.',
        },
      ],
    },
  },
];
